import React from "react";
import { useDispatch, useSelector } from "react-redux";
import useWindowSize from "./hooks/useWindowSize";
import downloadIcon from "../assets/images/download_icon.svg";
import {
  changeSection,
  toggleSectionContentDisplay,
} from "../store/auxiliary/ui/sections";
import { toggleMenu } from "../store/auxiliary/ui/generalSettings";
import { getContent } from "../assets/js/utils";

function FileDownloader(props) {
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  const windowWidth = useWindowSize();
  const dispatch = useDispatch();
  const handleDownloadContentDisplay = () => {
    if (generalSettings.menuOpen) {
      dispatch(toggleMenu());
    }
    dispatch(toggleSectionContentDisplay(true));
    dispatch(changeSection(getContent().sections.length));
  };
  return (
    <div className="file-downloader" onClick={handleDownloadContentDisplay}>
      {windowWidth < 1024 ? (
        <img src={downloadIcon} alt="" />
      ) : generalSettings.rtlLanguage ? (
        "مركز التحميل"
      ) : (
        "DOWNLOAD"
      )}
    </div>
  );
}

export default FileDownloader;
